import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/weibo': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M407 177.6c7.6-24-13.4-46.8-37.4-41.7-22 4.8-28.8-28.1-7.1-32.8 50.1-10.9 92.3 37.1 76.5 84.8-6.8 21.2-38.8 10.8-32-10.3zM214.8 446.7c-106.3 0-214.8-51.4-214.8-136.3 0-44.3 28-95.4 76.3-143.7 99.7-99.7 203.2-100.9 173.6-5.7-4 13.1 12.3 5.7 12.3 6 79.5-33.6 140.5-16.8 114 51.4-3.7 9.4 1.1 10.9 8.3 13.1 135.7 42.3 34.8 215.2-169.7 215.2zM358.5 300.4c-5.4-55.7-78.5-94-163.4-85.7-84.8 8.6-148.8 60.3-143.4 116 5.4 55.7 78.5 94 163.4 85.7 84.8-8.6 148.8-60.3 143.4-116zM347.9 35.1c102.3-21.6 189.3 74.5 157.4 174.3-8.3 25-44.8 12.2-37.4-12 23.1-71.2-39.4-139.2-111.7-124-25.1 5.4-34.2-32.7-8.3-38.3zM269.4 346.1c-17.1 38.8-66.8 60-109.1 46.3-40.8-13.1-58-53.4-40.3-89.7 17.7-35.4 63.1-55.4 103.4-45.1 42 10.8 63.1 50.2 46 88.5zM183.1 316.1c-12.9-5.4-30 0.3-38 12.9-8.3 12.9-4.3 28 8.6 34 13.1 6 30.8 0.3 39.1-12.9 8-13.1 3.7-28.3-9.7-34zM215.7 302.7c-5.1-1.7-11.4 0.6-14.3 5.4-2.9 5.1-1.4 10.6 3.7 12.9 5.1 2 11.7-0.3 14.6-5.4 2.8-5.2 1.1-10.9-4-12.9z'
      }
    ]
  }
})
